import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../../src/constants';
import { AuthUser, LoginCredentials, ApiResponse } from '../types';

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthUser> {
    const result = await apiClient.post<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.LOGIN, credentials, {
      authenticate: false,
    });
    return result.data ?? (result as unknown as AuthUser);
  },
  async loginAs(credentials: {
    userId: string;
  }): Promise<AuthUser> {
    const result = await apiClient.post<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.LOGINAS, credentials, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as AuthUser);
  },

  async signup(payload: any): Promise<AuthUser> {
    const result = await apiClient.post<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.SIGNUP, payload, {
      authenticate: false,
    });
    return result.data ?? (result as unknown as AuthUser);
  },

    async forgot(payload: { email: string }): Promise<any> {
      const result = await apiClient.post<ApiResponse<any>>(API_ENDPOINTS.AUTH.FORGOT, payload, {
        authenticate: false,
      });
      return result.data ?? result;
    },

    async checkHash(credentials: any): Promise<AuthUser> {
      const result = await apiClient.post<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.CHECKHASH, credentials, {
        authenticate: false,
      });
      return result.data ?? (result as unknown as AuthUser);
    },

    async setPasswordWithCheckHash(credentials: any): Promise<AuthUser> {
      const result = await apiClient.post<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.SETPASSWORD, credentials, {
        authenticate: false,
      });
      return result.data ?? (result as unknown as AuthUser);
    },

    async addTenantDetails(credentials: any): Promise<AuthUser> {
      const result = await apiClient.post<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.ADDTENANTDETAILS, credentials, {
        authenticate: true,
      });
      return result.data ?? (result as unknown as AuthUser);
    },
  

  async logout(): Promise<void> {
    try {
      await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT, undefined, { authenticate: true });
    } finally {
      localStorage.removeItem('agentic_auth_token');
      localStorage.removeItem('agentic_user_data');
      localStorage.removeItem('agentic_refresh_token');
      localStorage.removeItem('agentic_tenant_id');
      localStorage.removeItem('tenant_id');
    }
  },

  async refresh(): Promise<AuthUser> {
    const result = await apiClient.post<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.REFRESH, undefined, {
      authenticate: false,
    });
    return result.data ?? (result as unknown as AuthUser);
  },

  async profile(): Promise<AuthUser> {
    const result = await apiClient.get<ApiResponse<AuthUser>>(API_ENDPOINTS.AUTH.PROFILE, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as AuthUser);
  },
};


